<style lang="scss"></style>
<style lang="scss" scoped="scoped">
.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/super_big_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;display: flex;justify-content: space-between;padding: 10px 20px 10px 20px;">
    <div class="biankuang" style="height: 100%;width: 100%;display:flex;flex-direction: column;">
      <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
        当班生产统计
      </div>
      <div style="display:flex;justify-content:space-around;align-items:center;flex:1">
        <div>
          <div style="display: flex;align-items: center;">
            <img style="width: 36px;height: auto;" src="../../../../../../../assets/img/web/yongxin/目标产量.png" />
            <p style="color: white;font-size: 24px; margin-left: 8px;">生产目标</p>
          </div>
          <p v-if="dts.targetOutput" style="margin-top:4px;color: rgba(109, 223, 39, 1);font-weight: bold;font-size: 40px;">
            {{ dts.targetOutput == null ? 0 : dts.targetOutput }}
          </p>
        </div>
        <div>
          <div style="display: flex;align-items: center;">
            <img style="width: 36px;height: auto;" src="../../../../../../../assets/img/web/yongxin/实际产量.png" />
            <p style="color: white;font-size: 24px; margin-left: 8px;">生产实绩</p>
          </div>
          <p v-if="dts.actualOutput != null" style="margin-top:4px;color: rgba(109, 223, 39, 1);font-weight: bold;font-size: 40px;">
            {{ dts.actualOutput }}
          </p>
        </div>
        <div>
          <div style="display: flex;align-items: center;">
            <img style="width: 36px;height: auto;" src="../../../../../../../assets/img/web/yongxin/达成率.png" />
            <p style="color: white;font-size: 24px; margin-left: 8px;">达成率</p>
          </div>
          <p v-if="dts.achievementRate != null && dts.achievementRate > 0" style="margin-top:4px;color: rgba(109, 223, 39, 1);font-weight: bold;font-size: 40px;">{{ (dts.achievementRate * 100).toFixed(1) }}%</p>
        </div>
        <div>
          <div style="display: flex;align-items: center;">
            <img style="width: 36px;height: auto;" src="../../../../../../../assets/img/web/yongxin/稼动率.png" />
            <p style="color: white;font-size: 24px; margin-left: 8px;">稼动率</p>
          </div>
          <p v-if="dts.utilizationRate != null" style="margin-top:4px;color: rgba(109, 223, 39, 1);font-weight: bold;font-size: 40px;">{{ (dts.utilizationRate * 100).toFixed(1) }}%</p>
        </div>
        <div>
          <div style="display: flex;align-items: center;">
            <img style="width: 36px;height: auto;" src="../../../../../../../assets/img/web/yongxin/合格数.png" />
            <p style="color: white;font-size: 24px; margin-left: 8px;">良品数</p>
          </div>
          <p v-if="dts.qualifiedQuantity != null" style="margin-top:4px;color: rgba(109, 223, 39, 1);font-weight: bold;font-size: 40px;">
            {{ dts.qualifiedQuantity }}
          </p>
        </div>
        <div>
          <div style="display: flex;align-items: center;">
            <img style="width: 36px;height: auto;" src="../../../../../../../assets/img/web/yongxin/次品数次品率.png" />
            <p style="color: white;font-size: 24px; margin-left: 8px;">不良品数/不良率</p>
          </div>
          <p v-if="dts.qualifiedQuantity != null && dts.rejectRate != null" style="margin-top:4px;color:rgba(255, 18, 132, 1);font-weight: bold;font-size: 40px;">
            {{ dts.rejectQuantity + '/' + ((dts.rejectRate ? dts.rejectRate : 0) * 100).toFixed(2) + '%' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_sum',
  components: {},
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    }
  },
  data() {
    return {
      timer: null,
      dts: {}
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    console.log('$attrs', this.$attrs);
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/custom/yongxin/production/comprehensive/board', {});
      this.dts = response.data;
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => { }, 800);
    }
  }
};
</script>
